import { sortByFontName } from 'modules/campaigns/lib/hooks/useQueryBeeCustomFonts';
import { CustomFont } from 'modules/templateEditor/context/ContentEditorPreferencesContext';

/**
 * Generate a payload for creating a new custom font.
 */
export const generateCreateFontPayload = (customFonts: CustomFont[] = [], customFont: CustomFont) =>
  [...customFonts, customFont].sort(sortByFontName);

/**
 * Generate a payload for updating a custom font.
 */
export const generateUpdateFontPayload = (
  customFonts: CustomFont[] = [],
  originalFontName: string,
  updatedFont: CustomFont,
) => {
  const newCustomFonts: CustomFont[] = [...customFonts];

  const fontIndex = newCustomFonts.findIndex((font) => font.name === originalFontName);

  if (fontIndex === -1) {
    throw new Error('Font not found');
  }

  newCustomFonts[fontIndex] = updatedFont;
  newCustomFonts.sort(sortByFontName);

  return newCustomFonts;
};

/**
 * Generates a payload for deleting a custom font.
 */
export const generateDeleteFontPayload = (customFonts: CustomFont[] = [], fontName: string) =>
  customFonts.filter((customFont: CustomFont) => customFont.name !== fontName).sort(sortByFontName);
